import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
@Component({
  selector: 'Motor',
  templateUrl: './Motor.html',
  styleUrls: ['./Motor.css']
})
export class Motor {
   public License:boolean;
   public OTP:boolean;
   public Vehicle:boolean;
   public Count:number=1;
constructor(private router: Router){

}
  Next(){
    this.Count++;
    if(this.Count==2){
this.OTP=true;
this.License=false;
    }
    else if(this.Count==3){
      this.OTP=false;
      this.License=true;
    }
    else if(this.Count==4){
      this.Vehicle=true;
    }

  }

  Dashboard(){
this.router.navigate(['./Master/PolicyDashboard']);
  }
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Motor/Motor.ts